import { a11YAnyClickInWizardSrc121Evid105, a11YAnyClickInWizardTaskElementCopySrc121Evid114, a11YAnyClickInWizardTaskElementSrc121Evid112, a11YAnyClickInWizardTaskSrc121Evid109, a11YClickOnPageScanButtonSrc121Evid120, a11YDataOfManualTaskInWizardSrc121Evid123, a11YHoverOnPageScanButtonSrc121Evid119, a11YModalCloseSrc121Evid216, a11YModalCtaClickSrc121Evid215, a11YModalViewSrc121Evid214, a11YNotificationViewSrc121Evid210, a11YTooltipCtaClickSrc121Evid217, a11YTooltipViewSrc121Evid211, a11YWizardCardFinishLoadingSrc121Evid302, a11YWizardElementFieldUpdateSrc121Evid111, a11YWizardElementNotificationViewSrc121Evid118, a11YWizardElementStatusUpdateSrc121Evid110, a11YWizardNotificationCtaClickSrc121Evid213, a11YWizardPageExpandCollapseSrc121Evid107, a11YWizardPageScanFinishedBreakdownPerTaskTypeVerticalsPagesOnlySrc121Evid125, a11YWizardPanelCloseSrc121Evid113, a11YWizardPanelOpenSrc121Evid115, a11YWizardScanFinishedCopyCopySrc121Evid104, a11YWizardScanFinishedCopySrc121Evid102, a11YWizardScanFinishedSrc121Evid101, a11YWizardSectionExpandCollapseSrc121Evid307, a11YWizardSiteScanFinishedBreakdownPerTaskTypeSrc121Evid100, a11YWizardTaskExpandCollapseSrc121Evid108, a11YWizardTaskNotificationCtaClickSrc121Evid117, a11YWizardTaskNotificationViewSrc121Evid116, a11YWizardTaskStatusUpdateSrc121Evid106 } from '@wix/bi-logger-accessibility-data/v2';
import webBiLogger from '@wix/web-bi-logger';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { currentTaskInfoAtom, prevScanTimestampAtom } from '../atoms/bi-atoms';
import { getFullView, getTaskCount } from '../bi';
import { BiScreenTypes } from '../bi/types';
import { useA11yWizardAdapter } from './use-a11y-wizard-adapter';
import { useBiCommon } from './use-bi-common';
import { useSessionInfoContext } from './use-session-info-context';
const getNotificationCounts = payload => {
  if ('isApplied' in payload) {
    return {
      elementCount: payload.nonGenericSuggestion + payload.genericSuggestion,
      failedElementCount: -1
    };
  }
  const failedElementCount = payload.failed + payload.unsupportedTotal;
  return {
    elementCount: failedElementCount + payload.generated,
    failedElementCount
  };
};
export const useBiLogger = () => {
  const origin = 'a11y_wizard';
  const {
    a11yWizardAdapter,
    editorHost
  } = useA11yWizardAdapter();
  const {
    referral
  } = useSessionInfoContext();
  const logger = useMemo(() => webBiLogger.factory().logger(), []);
  const taskInfoParams = useAtomValue(currentTaskInfoAtom);
  const previousScanTimestamp = useAtomValue(prevScanTimestampAtom);
  const {
    screenType,
    commonParams
  } = useBiCommon();
  return useMemo(() => {
    return {
      ctaClick: /* 105 */_ref => {
        let {
          ctaName = ''
        } = _ref;
        logger.report(a11YAnyClickInWizardSrc121Evid105({
          name: ctaName,
          screen_type: screenType,
          ...commonParams
        }));
      },
      elementFieldChange: /* 111 */_ref2 => {
        let {
          value,
          fieldName,
          index,
          status,
          isManual
        } = _ref2;
        logger.report(a11YWizardElementFieldUpdateSrc121Evid111({
          ...commonParams,
          ...taskInfoParams,
          element_index: index,
          element_status: status,
          element_value: value,
          field_name: fieldName ?? taskInfoParams.task_name,
          is_manual: isManual,
          page_scan_timestamp: commonParams.site_scan_timestamp,
          task_status: taskInfoParams.status
        }));
      },
      elementNotificationView: _ref3 => {
        let {
          notificationType,
          elementStatus,
          elementIndex
        } = _ref3;
        /* 118 */
        logger.report(a11YWizardElementNotificationViewSrc121Evid118({
          element_index: elementIndex,
          element_status: elementStatus,
          notification_type: notificationType,
          ...commonParams,
          ...taskInfoParams
        }));
      },
      elementStatusChange: /* 110 */_ref4 => {
        let {
          status,
          index,
          value,
          isAiGenerated,
          isManual
        } = _ref4;
        logger.report(a11YWizardElementStatusUpdateSrc121Evid110({
          ...taskInfoParams,
          task_status: taskInfoParams.status,
          ...commonParams,
          element_index: index,
          element_status: status,
          element_value: value,
          is_ai_generated: isAiGenerated,
          is_manual: isManual,
          site_scan_timestamp: previousScanTimestamp
        }));
      },
      manualTaskData: /* 123 */_ref5 => {
        let {
          taskName,
          elementCount,
          failedElementCount,
          manualElementCount,
          manualFailedElementCount,
          genericElementsData
        } = _ref5;
        logger.report(a11YDataOfManualTaskInWizardSrc121Evid123({
          ...commonParams,
          ...taskInfoParams,
          element_count: elementCount,
          failed_element_count: failedElementCount,
          manual_element_count: manualElementCount,
          manual_failed_element_count: manualFailedElementCount,
          payload: genericElementsData,
          task_name: taskName,
          task_status: taskInfoParams.status
        }));
      },
      modalClose: /* 216 */_ref6 => {
        let {
          modalType
        } = _ref6;
        logger.report(a11YModalCloseSrc121Evid216({
          modal_type: modalType,
          origin,
          ...commonParams
        }));
      },
      modalCtaClick: /* 215 */_ref7 => {
        let {
          modalType,
          ctaName
        } = _ref7;
        logger.report(a11YModalCtaClickSrc121Evid215({
          cta_type: ctaName,
          modal_type: modalType,
          origin,
          screenType,
          ...commonParams
        }));
      },
      modalView: /* 214 */_ref8 => {
        let {
          modalType,
          data
        } = _ref8;
        logger.report(a11YModalViewSrc121Evid214({
          data,
          modal_type: modalType,
          origin,
          screenType,
          ...commonParams
        }));
      },
      notificationCtaClick: /* 213 */_ref9 => {
        let {
          notificationType,
          ctaName
        } = _ref9;
        logger.report(a11YWizardNotificationCtaClickSrc121Evid213({
          ...commonParams,
          cta_type: ctaName,
          notification_type: notificationType,
          origin,
          screenType
        }));
      },
      notificationView: /* 210 */_ref0 => {
        let {
          notificationType
        } = _ref0;
        logger.report(a11YNotificationViewSrc121Evid210({
          ...commonParams,
          notification_type: notificationType,
          origin,
          screenType
        }));
      },
      pageExpandCollapse: /* 107 */_ref1 => {
        let {
          toggleType,
          initiatedByUser,
          ruleResults,
          pageId,
          pageIndex,
          pageType
        } = _ref1;
        const {
          total: taskCount,
          fail: failedTaskCount
        } = getTaskCount(ruleResults);
        logger.report(a11YWizardPageExpandCollapseSrc121Evid107({
          expand_collapse: toggleType,
          failed_task_count: failedTaskCount,
          is_automatic: !initiatedByUser,
          page_scan_timestamp: commonParams.site_scan_timestamp,
          task_count: taskCount,
          ...commonParams,
          page_id: pageId,
          page_index: pageIndex,
          page_type: pageType
        }));
      },
      pageScanClick: /* 120 */_ref10 => {
        let {
          taskCount,
          failedTaskCount,
          pageId
        } = _ref10;
        logger.report(a11YClickOnPageScanButtonSrc121Evid120({
          failed_task_count: failedTaskCount,
          task_count: taskCount,
          ...taskInfoParams,
          ...commonParams,
          page_id: pageId
        }));
      },
      pageScanFinished: /* 102 */_ref11 => {
        let {
          analysisJobId,
          pageType,
          pageId,
          issuesCount
        } = _ref11;
        logger.report(a11YWizardScanFinishedCopySrc121Evid102({
          issues_count: issuesCount ?? -1,
          job_analysis_id: analysisJobId,
          origin: referral || a11yWizardAdapter.getEntryPoint() || BiScreenTypes.Direct,
          page_id: pageId,
          page_type: pageType,
          ...commonParams
        }));
      },
      pageScanTooltipView: /* 119 */_ref12 => {
        let {
          taskCount,
          failedTaskCount,
          tooltipName
        } = _ref12;
        logger.report(a11YHoverOnPageScanButtonSrc121Evid119({
          failed_task_count: failedTaskCount,
          name: tooltipName,
          task_count: taskCount,
          ...taskInfoParams,
          ...commonParams
        }));
      },
      panelView: /* 104 */_ref13 => {
        let {
          ruleGroups,
          detectedIssuesNumber,
          manualTasksNumber
        } = _ref13;
        const fullView = getFullView(a11yWizardAdapter, ruleGroups, detectedIssuesNumber, manualTasksNumber);
        logger.report(a11YWizardScanFinishedCopyCopySrc121Evid104({
          full_view: fullView,
          origin: referral || a11yWizardAdapter.getEntryPoint() || BiScreenTypes.Direct,
          screen_type: screenType,
          ...commonParams
        }));
      },
      scanSiteFinished: /* 101 */_ref14 => {
        let {
          failed_task_count,
          origin: originParam,
          isFirstScan,
          task_count
        } = _ref14;
        logger.report(a11YWizardScanFinishedSrc121Evid101({
          failed_task_count,
          is_first_scan: isFirstScan,
          origin: originParam,
          task_count,
          ...commonParams
        }));
      },
      scanSiteFinishedBreakdownPerTask: /* 100 */_ref15 => {
        let {
          origin: originParam,
          taskName,
          payload,
          taskCount,
          failedTaskCount
        } = _ref15;
        logger.report(a11YWizardSiteScanFinishedBreakdownPerTaskTypeSrc121Evid100({
          failed_task_count: failedTaskCount,
          origin: originParam,
          payload: JSON.stringify(payload),
          task_count: taskCount,
          task_name: taskName,
          ...commonParams
        }));
      },
      scanSiteFinishedBreakdownPerTaskVerticalsPages: /* 125 */ruleElement => {
        logger.report(a11YWizardPageScanFinishedBreakdownPerTaskTypeVerticalsPagesOnlySrc121Evid125({
          ...ruleElement,
          ...commonParams,
          origin: referral || a11yWizardAdapter.getEntryPoint() || BiScreenTypes.Direct
        }));
      },
      taskCtaClick: /* 109 */_ref16 => {
        let {
          ctaName,
          elementCount,
          failedElementCount
        } = _ref16;
        logger.report(a11YAnyClickInWizardTaskSrc121Evid109({
          ...commonParams,
          ...taskInfoParams,
          cta_type: ctaName,
          element_count: elementCount,
          failed_element_count: failedElementCount,
          page_scan_timestamp: commonParams.site_scan_timestamp,
          task_status: taskInfoParams.status
        }));
      },
      taskElementApplyClick: /* 114 */_ref17 => {
        let {
          value,
          status,
          elementIndexList,
          elementStatusList,
          elementValueList,
          index
        } = _ref17;
        logger.report(a11YAnyClickInWizardTaskElementCopySrc121Evid114({
          ...commonParams,
          ...taskInfoParams,
          element_index: index,
          element_index_list: elementIndexList == null ? void 0 : elementIndexList.join(','),
          element_status: elementValueList != null && elementValueList.length ? undefined : status,
          element_status_list: elementStatusList == null ? void 0 : elementStatusList.join(','),
          element_value: value,
          element_value_list: elementIndexList && elementValueList ? JSON.stringify(Object.fromEntries(elementIndexList.map((elementIndex, i) => [elementIndex, elementValueList[i]]))) : undefined,
          task_status: taskInfoParams.status
        }));
      },
      taskElementCtaClick: /* 112 */_ref18 => {
        let {
          ctaName,
          index,
          status,
          isManual
        } = _ref18;
        logger.report(a11YAnyClickInWizardTaskElementSrc121Evid112({
          ...commonParams,
          ...taskInfoParams,
          cta_type: ctaName,
          element_index: index,
          element_status: status,
          is_manual: isManual,
          page_scan_timestamp: commonParams.site_scan_timestamp,
          task_status: taskInfoParams.status
        }));
      },
      taskExpandCollapse: /* 108 */_ref19 => {
        let {
          toggleType,
          initiatedByUser,
          taskInfo,
          elementCount,
          failedElementCount,
          manualElementCount = -1,
          manualFailedElementCount = -1
        } = _ref19;
        logger.report(a11YWizardTaskExpandCollapseSrc121Evid108({
          ...commonParams,
          ...taskInfo,
          element_count: elementCount,
          expand_collapse: toggleType,
          failed_element_count: failedElementCount,
          is_automatic: !initiatedByUser,
          manual_element_count: manualElementCount,
          manual_failed_element_count: manualFailedElementCount,
          page_scan_timestamp: commonParams.site_scan_timestamp,
          task_status: taskInfo.status
        }));
      },
      taskNotificationCtaClick: /* 117 */_ref20 => {
        let {
          notificationType,
          payload,
          ctaName
        } = _ref20;
        const {
          elementCount,
          failedElementCount
        } = getNotificationCounts(payload);
        logger.report(a11YWizardTaskNotificationCtaClickSrc121Evid117({
          ...commonParams,
          ...taskInfoParams,
          cta_type: ctaName,
          element_count: elementCount,
          failed_element_count: failedElementCount,
          notification_type: notificationType,
          payload: JSON.stringify(payload)
        }));
      },
      taskNotificationView: /* 116 */_ref21 => {
        let {
          notificationType,
          payload
        } = _ref21;
        const {
          elementCount,
          failedElementCount
        } = getNotificationCounts(payload);
        logger.report(a11YWizardTaskNotificationViewSrc121Evid116({
          ...commonParams,
          ...taskInfoParams,
          element_count: elementCount,
          failed_element_count: failedElementCount,
          notification_type: notificationType,
          payload: JSON.stringify(payload)
        }));
      },
      taskStatusChange: /* 106 */_ref22 => {
        let {
          status,
          elementCount,
          failedElementCount,
          manualElementCount = -1,
          manualFailedElementCount = -1
        } = _ref22;
        logger.report(a11YWizardTaskStatusUpdateSrc121Evid106({
          ...commonParams,
          ...taskInfoParams,
          element_count: elementCount,
          failed_element_count: failedElementCount,
          manual_element_count: manualElementCount,
          manual_failed_element_count: manualFailedElementCount,
          site_scan_timestamp: previousScanTimestamp,
          task_status: status
        }));
      },
      tooltipCtaClick: /* 217 */_ref23 => {
        let {
          tooltipName,
          ctaName
        } = _ref23;
        const {
          msid
        } = commonParams;
        logger.report(a11YTooltipCtaClickSrc121Evid217({
          cta_type: ctaName,
          msid,
          origin,
          tooltip_name: tooltipName
        }));
      },
      tooltipView: /* 211 */_ref24 => {
        let {
          tooltipName,
          tooltipOrigin,
          data
        } = _ref24;
        const {
          msid
        } = commonParams;
        logger.report(a11YTooltipViewSrc121Evid211({
          data,
          msid,
          origin: tooltipOrigin ?? origin,
          tooltip_name: tooltipName
        }));
      },
      wizardCardFinishLoading: /* 302 */_ref25 => {
        let {
          cardName,
          issueCount
        } = _ref25;
        logger.report(a11YWizardCardFinishLoadingSrc121Evid302({
          card_name: cardName,
          editor_type: editorHost,
          esi: commonParams.esi,
          issue_count: issueCount,
          wizard_session_start_ts: commonParams.wizard_session_start_ts
        }));
      },
      wizardPanelClose: /* 113 */() => {
        logger.report(a11YWizardPanelCloseSrc121Evid113({
          origin: referral || a11yWizardAdapter.getEntryPoint() || BiScreenTypes.Direct,
          screen_type: screenType,
          ...commonParams
        }));
      },
      wizardPanelOpen: /* 115 */() => {
        logger.report(a11YWizardPanelOpenSrc121Evid115({
          origin: referral || a11yWizardAdapter.getEntryPoint() || BiScreenTypes.Direct,
          screen_type: screenType,
          ...commonParams
        }));
      },
      wizardSectionExpandCollapse: /* 307 */_ref26 => {
        let {
          toggleType,
          isAutomatic,
          issueCount,
          pagesCount,
          pagesWithIssueCount,
          cardName
        } = _ref26;
        logger.report(a11YWizardSectionExpandCollapseSrc121Evid307({
          card_name: cardName,
          editor_type: editorHost,
          esi: commonParams.esi,
          expand_collapse: toggleType,
          is_automatic: isAutomatic,
          issue_count: issueCount,
          pages_count: pagesCount,
          pages_with_issue_count: pagesWithIssueCount,
          site_scan_timestamp: commonParams.site_scan_timestamp,
          wizard_session_start_ts: commonParams.wizard_session_start_ts
        }));
      }
    };
  }, [a11yWizardAdapter, commonParams, editorHost, logger, previousScanTimestamp, referral, screenType, taskInfoParams]);
};
//# sourceMappingURL=use-bi-logger.js.map